// 유저가 CSS에서 허용하는 형태의 색상 코드를 입력했을 때 RGBA라는 통일된 형태로 반환하는 함수
// e.g. #FFFFFF -> rgba(255, 255, 255, 1)
// e.g. rgba(255, 255, 255, 1) -> rgba(255, 255, 255, 1)
// e.g. red -> rgba(255, 0, 0, 1)
function colorToRgba(color: string, alpha: number = 1): string {
    const canvas = document.createElement('canvas');
    canvas.width = canvas.height = 1;
    const ctx = canvas.getContext('2d');
    
    if (!ctx) return `rgba(0, 0, 0, ${alpha})`;
    
    ctx.fillStyle = color;
    ctx.fillRect(0, 0, 1, 1);
    const data = ctx.getImageData(0, 0, 1, 1).data;
    const r = data[0];
    const g = data[1];
    const b = data[2];
    
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

export default colorToRgba;